import { useCallback, useEffect, useRef } from "react";
import { isLocal } from "../services/serviceConfig";

const SCRIPT_TEXT = "(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:6585380,hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');";

export const useHotjarScript = () => {
    const { current: script } = useRef(document.createElement("script"));

    const isScriptAdded = useRef(false);

    const appendScript = useCallback(() => {
        if (!script || isScriptAdded.current) return;

        script.innerText = SCRIPT_TEXT;
        document.head.appendChild(script);
        isScriptAdded.current = true;
    }, [script, isScriptAdded]);
    const removeScript = useCallback(() => {
        if (!script || !isScriptAdded.current) return;
        document.head.removeChild(script);
        isScriptAdded.current = false;
    }, [script, isScriptAdded]);

    useEffect(() => {
        if (!isLocal) appendScript();
    }, [appendScript]);
};
